import { NextPage } from 'next';
import Head from 'next/head';
import React from 'react';

import TemplateQuemSomos from '@/templates/quem-somos';

const QuemSomos: NextPage = props => {
  return (
    <>
      <Head>
        <title>Quem Somos | BoraTickets</title>
      </Head>
      <TemplateQuemSomos />
    </>
  );
};

export default QuemSomos;
